import { useRef, useState } from "react";
import { Col, Form, Row, Button, Placeholder } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SelectDropdownForm from "../components-forms/SelectDropdownForm";
import SuggestionWidget from "./SuggestionWidget";
import InputTextForm from "../components-forms/InputTextForm";
import ChipsControl from "./ChipsControl";
import SelectBodyArea from "../components-forms/SelectBodyArea";
import SelectGenders from "../components-forms/SelectGenders";
import SelectFitType from "../components-forms/SelectFitType";
import ModalCommon from "./ModalCommon";
import {
  BodyAreaServices,
  FitTypeServices,
  PersonServices,
  SizeGuideServices,
} from "../../../services";
import MultiselectDropdownForm from "../components-forms/MultiselectDropdownForm";
import { IBaseItem, IProduct, ISizeGuide, ISizeModel } from "../types";
import FileUpdloadForm from "../components-forms/FileUploadForm";
import { ExcelModule } from "../../../misc";
import { finished } from "stream";
import "./ProductsForm.css";
import { FormattedMessage, useIntl } from "react-intl";

const ProductsForm = (props: any) => {
  const [showModal, setShowModal] = useState(false);

  const [isLoadingData, setIsLoadingData] = useState(false);
  const [isLoadingSizeGuides, setIsLoadingSizeGuides] = useState(false);
  const [SizeGuides, setSizeGuides] = useState<any[]>();
  const [SizeGuideSelected, setSizeGuideSelected] = useState<any>(null);
  const [SizesGuideSelect, setSizesGuideSelect] = useState<any[]>([]);
  const [SizeGuideType, setSizeGuideType] = useState<any>();
  const [SizeGuideGender, setSizeGuideGender] = useState<any>();
  const [selectedSizes, setSelectedSizes] = useState<any[]>([]);
  const [selectedSizesNames, setSelectedSizesNames] = useState<any[]>([]);
  const [itemEdit, setItemEdit] = useState<any>(null);
  const [selectedChips, setSelectedChips] = useState([]); // Lift the state to the parent component
  const [chipsDisabled, setChipsDisabled] = useState(false);

  const intl = useIntl();

  const fileUploadRef = useRef<any>(null);

  async function getSizeGuides() {
    try {
      setIsLoadingSizeGuides(true);

      const getSizeGuides = await SizeGuideServices.GetSizesGuides();

      if (getSizeGuides && getSizeGuides.Status === 200) {
        setSizeGuides(getSizeGuides.Content);
      } else {
        setSizeGuides([]);
      }

      setIsLoadingSizeGuides(false);
    } catch (error) {
      console.log(error);

      setIsLoadingSizeGuides(false);
    }
  }

  async function getSizeGuidesUpload() {
    try {
      const getSizeGuides = await SizeGuideServices.GetSizesGuides();

      if (getSizeGuides && getSizeGuides.Status === 200) {
        setSizeGuides(getSizeGuides.Content);
        return getSizeGuides.Content;
      } else {
        setSizeGuides([]);
        return [];
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function getBodyAreas() {
    try {
      const getResponse = await BodyAreaServices.GetBodyAreas();

      if (getResponse) {
        return getResponse;
      } else {
        return new Array<IBaseItem>();
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function getGenders() {
    try {
      const getResponse = await PersonServices.GetGenders();

      if (getResponse) {
        return getResponse;
      } else {
        return new Array<IBaseItem>();
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function getFitTypes() {
    try {
      const getResponse = await FitTypeServices.GetFitTypes();

      if (getResponse) {
        return getResponse;
      } else {
        return new Array<IBaseItem>();
      }
    } catch (error) {
      console.log(error);
    }
  }
  const createNewRowProduct = (indice: number) => {
    let newProduct: IProduct;
    let newId: number = indice;

    try {
      if (indice > 0) {
        const currentElements = [...props.Elements];

        newId = currentElements[currentElements.length - 1].Id;
      }

      newProduct = {
        Id: indice + 1,
        Name: "",
        Code: "",
        Variants: new Array<string>(),
        BodyArea: { Id: 4, Name: "" },
        Gender: { Id: 3, Name: "" },
        Fit: { Id: 1, Name: "" },
        Categories: new Array<string>(),
        SizeGuide: null,
        Sizes: null,
        PositionRow: indice,
      };

      return newProduct;
    } catch (error) {
      console.log(error);
    }

    return undefined;
  };

  const onProductCodeChange = (
    index: number,
    value: string,
    item: IProduct
  ) => {
    try {
      const newProducts = [...props.Elements];
      const currentProduct = newProducts[index];

      currentProduct.Code = value ? value : "";

      if (props.SuscribeChanges) props.SuscribeChanges(newProducts);
    } catch (error) {
      console.log(error);
    }
  };

  const onProductVariantsChange = (
    index: number,
    values: string[],
    item: IProduct
  ) => {
    try {
      const newProducts = [...props.Elements];
      const currentProduct = newProducts[index];

      currentProduct.Variants = values ? values : [];

      if (props.SuscribeChanges) props.SuscribeChanges(newProducts);
    } catch (error) {
      console.log(error);
    }
  };

  const onProductNameChange = (
    index: number,
    value: string,
    item: IProduct
  ) => {
    try {
      const newProducts = [...props.Elements];
      const currentProduct = newProducts[index];

      currentProduct.Name = value ? value : "";

      if (props.SuscribeChanges) props.SuscribeChanges(newProducts);
    } catch (error) {
      console.log(error);
    }
  };

  const onProductBodyAreaChange = (
    index: number,
    value: number,
    item: IProduct
  ) => {
    try {
      const newProducts = [...props.Elements];
      const currentProduct = newProducts[index];

      currentProduct.BodyArea.Id = value ? value : 0;

      if (props.SuscribeChanges) props.SuscribeChanges(newProducts);
    } catch (error) {
      console.log(error);
    }
  };

  const onProductGenderChange = (
    index: number,
    value: number,
    item: IProduct
  ) => {
    try {
      const newProducts = [...props.Elements];
      const currentProduct = newProducts[index];

      currentProduct.Gender.Id = value ? value : 0;

      if (props.SuscribeChanges) props.SuscribeChanges(newProducts);
    } catch (error) {
      console.log(error);
    }
  };

  const onProductFitChange = (index: number, value: number, item: IProduct) => {
    try {
      const newProducts = [...props.Elements];
      const currentProduct = newProducts[index];

      currentProduct.Fit.Id = value ? value : 0;

      if (props.SuscribeChanges) props.SuscribeChanges(newProducts);
    } catch (error) {
      console.log(error);
    }
  };

  const onProductCategoriesChange = (
    index: number,
    values: string[],
    item: IProduct
  ) => {
    try {
      const newProducts = [...props.Elements];
      const currentProduct = newProducts[index];

      currentProduct.Categories = values ? values : [];

      if (props.SuscribeChanges) props.SuscribeChanges(newProducts);
    } catch (error) {
      console.log(error);
    }
  };

  const onProductRemoveSizeGuide = (index: number, item: IProduct) => {
    try {
      const newProducts = [...props.Elements];
      const currentProduct = newProducts[index];

      currentProduct.SizeGuide = null;
      currentProduct.Sizes = null;

      if (props.SuscribeChanges) props.SuscribeChanges(newProducts);
    } catch (error) {
      console.log(error);
    }
  };

  const onProductRemove = (index: number, item: IProduct) => {
    try {
      if (index > 0) {
        const newProducts = [...props.Elements];
        newProducts.splice(index, 1);

        if (props.SuscribeChanges) props.SuscribeChanges(newProducts);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onProductAdd = () => {
    try {
      const newProducts = [...props.Elements];

      const newProduct = createNewRowProduct(newProducts.length);

      if (newProducts) {
        newProducts.push(newProduct);

        if (props.SuscribeChanges) props.SuscribeChanges(newProducts);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onShowModal = (index: number, item: IProduct) => {
    try {
      if (!SizeGuides) {
        getSizeGuides();
      }

      setSizeGuideSelected(null);
      setSelectedSizes([]);
      setSizeGuideGender(null);
      setSizeGuideType(null);
      setItemEdit({ Index: index, Item: item });
      setShowModal(true);
    } catch (error) {
      console.log(error);
    }
  };

  const onHideModal = () => {
    setShowModal(false);

    setSizeGuideSelected(null);
    setSelectedSizes([]);
    setSizeGuideGender(null);
    setSizeGuideType(null);
    setItemEdit(null);
  };

  const onOkModal = () => {
    try {
      setShowModal(false);

      const newProducts = [...props.Elements];
      const currentProduct = newProducts[itemEdit.Index];

      currentProduct.SizeGuide = SizeGuideSelected ? SizeGuideSelected : null;
      currentProduct.Sizes = selectedSizes ? selectedSizes : null;

      if (props.SuscribeChanges) props.SuscribeChanges(newProducts);

      // Disable the ChipsControl
      setChipsDisabled(true); // Add this line
    } catch (error) {
      console.log(error);
    }
  };

  const onSizeGuideChange = (value: any) => {
    try {
      const guideSelect = SizeGuides?.find((guide: any) => {
        return guide.Id === parseInt(value);
      });

      if (guideSelect) {
        setSizeGuideSelected(guideSelect);
        setSizeGuideType(guideSelect.TypeSizeGuide);
        setSizeGuideGender(guideSelect.Gender);

        setSizesGuideSelect(
          guideSelect.Sizes.map((element: any) => {
            return {
              name: element.Name,
              code: element.Id,
            };
          })
        );
      } else {
        setSizeGuideSelected(null);
        setSizeGuideType(null);
        setSizeGuideGender(null);
        setSizesGuideSelect([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onSizesChange = (value: any) => {
    try {
      setSelectedChips(value ? value : []);
      const selectedOptions = value
        ? [].map.call(value, (elemento: any) => {
            return { Id: elemento.code, Name: elemento.name };
          })
        : [];
      setSelectedSizes(selectedOptions);
      setSelectedSizesNames(
        selectedOptions.map((elemento: any) => elemento.Name)
      );
    } catch (error) {
      console.log(error);
    }
  };

  const ModalContent = () => {
    return (
      <Form className="not-found-items-modal-container">
        <>
          <Row>
            <Col>
              <SelectDropdownForm
                Elements={SizeGuides}
                IsLoading={isLoadingSizeGuides}
                Label="products-form-selectguide"
                // Label={"Selecciona una guía"}
                Classname={"products-form-dashboard-modal-select"}
                AriaLabel={"Default select example"}
                OptionDefault={true}
                SuscribedChange={onSizeGuideChange}
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              <p className="my-0">
                <span className="not-found-items-props-bold">
                  <FormattedMessage
                    id="ready-size-guide-type"
                    defaultMessage="Tipo de Guía:"
                  />
                </span>{" "}
                {SizeGuideType?.Name || ""}
              </p>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              <p className="my-0">
                <span className="not-found-items-props-bold">
                  <FormattedMessage
                    id="ready-size-gender"
                    defaultMessage="Género:"
                  />
                </span>{" "}
                {SizeGuideGender?.Name || ""}
              </p>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              <MultiselectDropdownForm
                SelectedValues={selectedSizes}
                Options={SizesGuideSelect}
                Placeholder="products-form-select-sizes"
                // Placeholder={"Seleccionar talles"}
                SuscribedChange={onSizesChange}
              />
            </Col>
          </Row>
          <Row className="mt-3 justify-content-center">
            <Col xs={11}>
              <SuggestionWidget
                title=" "
                description={
                  <FormattedMessage
                    id="products-form-suggestionwidget-notfoundguide"
                    defaultMessage="Si no encuentras la guía que buscas, puedes darla de alta."
                  />
                }
              />
            </Col>
          </Row>
        </>
      </Form>
    );
  };

  const helperModelo = () => {
    return (
      <>
        <div className="model-helper-main-container">
          <p className="model-helper-text-title">
            <FormattedMessage
              id="products-form-helper-title"
              defaultMessage="Este código puede tener diferente nombre de acuerdo a tu tienda."
            />
          </p>
          <p className="model-helper-text-example">
            <FormattedMessage
              id="products-form-helper-example"
              defaultMessage="Ejemplos:"
            />
          </p>
          <div className="model-helper-icons-container">
            <div className="model-helper-icons-row">
              <img src="/img/magento.png" alt="magento-icon" />
              <p className="model-helper-text">
                <span className="model-helper-bold">Magento:</span> SKU
              </p>
            </div>
            <div className="model-helper-icons-row">
              <img src="/img/vtex.png" alt="vtex-icon" />
              <p className="model-helper-text">
                <span className="model-helper-bold">Vtex:</span>{" "}
                Product_Reference
              </p>
            </div>
            <div className="model-helper-icons-row">
              <img src="/img/shopify.png" alt="shopify-icon" />
              <p className="model-helper-text">
                <span className="model-helper-bold">Shopify:</span> SKU
              </p>
            </div>
            <div className="model-helper-tn-icon-row">
              <img src="/img/tiendanube.png" alt="shopify-icon" />
              <p className="model-helper-text-tn">
                <span className="model-helper-bold">Shopify:</span> Barcode
              </p>
            </div>
          </div>
        </div>
      </>
    );
  };

  // const helperDescription = () => {
  //   return (
  //     <>
  //       <div>
  //         <p>Soy Ayuda de Descripción</p>
  //       </div>
  //     </>
  //   );
  // };

  const onImportExcel = async (e: any) => {
    let uploadSizeGuides: any[];
    let bodyAreas: IBaseItem[] | undefined;
    let genders: IBaseItem[] | undefined;
    let fitTypes: IBaseItem[] | undefined;

    try {
      if (fileUploadRef.current.value) {
        setIsLoadingData(true);

        uploadSizeGuides = await getSizeGuidesUpload();
        bodyAreas = await getBodyAreas();
        genders = await getGenders();
        fitTypes = await getFitTypes();

        ExcelModule.ImportFrom(e.target, (data: any) => {
          if (data) {
            const currentProducts = [...props.Elements];

            // console.log('IMPORT FILE DATA', data);

            [].forEach.call(data, (element: any, index: number) => {
              if (currentProducts[currentProducts.length - 1].Code === "") {
                currentProducts[currentProducts.length - 1].Code =
                  element.Modelo;
                currentProducts[currentProducts.length - 1].Name =
                  element.Descripcion;

                if (element.SKUs)
                  currentProducts[currentProducts.length - 1].Variants =
                    element.SKUs.split(",");

                if (element.Fit && fitTypes) {
                  const findItem = fitTypes.find((findElement: IBaseItem) => {
                    return (
                      findElement.Name.toUpperCase() ===
                      element.Fit.toUpperCase()
                    );
                  });

                  currentProducts[currentProducts.length - 1].Fit = findItem
                    ? findItem
                    : { Id: 1, Name: "" };
                }

                if (element.Genero && genders) {
                  const findItem = genders.find((findElement: IBaseItem) => {
                    return (
                      findElement.Name.toUpperCase() ===
                      element.Genero.toUpperCase()
                    );
                  });

                  currentProducts[currentProducts.length - 1].Gender = findItem
                    ? findItem
                    : { Id: 3, Name: "" };
                }

                if (element.Posicion && bodyAreas) {
                  const findItem = bodyAreas.find((findElement: IBaseItem) => {
                    return (
                      findElement.Name.toUpperCase() ===
                      element.Posicion.toUpperCase()
                    );
                  });

                  currentProducts[currentProducts.length - 1].BodyArea =
                    findItem ? findItem : { Id: 4, Name: "" };
                }

                if (element.Guia && uploadSizeGuides) {
                  const findItem = uploadSizeGuides.find(
                    (findElement: ISizeGuide) => {
                      return (
                        findElement.Name.toUpperCase() ===
                        element.Guia.toUpperCase()
                      );
                    }
                  );

                  currentProducts[currentProducts.length - 1].SizeGuide =
                    findItem ? findItem : null;

                  if (element.Talles && findItem) {
                    const sizes: ISizeModel[] = new Array<ISizeModel>();

                    [].forEach.call(
                      element.Talles.split(","),
                      (talleElement: any) => {
                        const findSizeItem = findItem.Sizes.find(
                          (findSizeElement: ISizeModel) => {
                            return (
                              findSizeElement.Name.toUpperCase() ===
                              talleElement.trim().toUpperCase()
                            );
                          }
                        );

                        if (findSizeItem) {
                          sizes.push(findSizeItem);
                        }
                      }
                    );

                    currentProducts[currentProducts.length - 1].Sizes =
                      sizes && sizes.length > 0 ? sizes : null;
                  }
                }

                if (element.Categorias)
                  currentProducts[currentProducts.length - 1].Categories =
                    element.Categorias.split(",");
              } else {
                const newProduct = createNewRowProduct(currentProducts.length);

                if (newProduct) {
                  newProduct.Code = element.Modelo;
                  newProduct.Name = element.Descripcion;

                  if (element.SKUs)
                    newProduct.Variants = element.SKUs.split(",");

                  if (element.Fit) {
                    const findItem = fitTypes?.find(
                      (findElement: IBaseItem) => {
                        return (
                          findElement.Name.toUpperCase() ===
                          element.Fit.toUpperCase()
                        );
                      }
                    );

                    newProduct.Fit = findItem ? findItem : { Id: 1, Name: "" };
                  }

                  if (element.Genero) {
                    const findItem = genders?.find((findElement: IBaseItem) => {
                      return (
                        findElement.Name.toUpperCase() ===
                        element.Genero.toUpperCase()
                      );
                    });

                    newProduct.Gender = findItem
                      ? findItem
                      : { Id: 3, Name: "" };
                  }

                  if (element.Posicion) {
                    const findItem = bodyAreas?.find(
                      (findElement: IBaseItem) => {
                        return (
                          findElement.Name.toUpperCase() ===
                          element.Posicion.toUpperCase()
                        );
                      }
                    );

                    newProduct.BodyArea = findItem
                      ? findItem
                      : { Id: 4, Name: "" };
                  }

                  if (element.Guia) {
                    const findItem = uploadSizeGuides?.find(
                      (findElement: ISizeGuide) => {
                        return (
                          findElement.Name.toUpperCase() ===
                          element.Guia.toUpperCase()
                        );
                      }
                    );

                    newProduct.SizeGuide = findItem ? findItem : null;

                    if (element.Talles && findItem) {
                      const sizes: ISizeModel[] = new Array<ISizeModel>();

                      [].forEach.call(
                        element.Talles.split(","),
                        (talleElement: any) => {
                          const findSizeItem = findItem.Sizes.find(
                            (findSizeElement: ISizeModel) => {
                              return (
                                findSizeElement.Name.toUpperCase() ===
                                talleElement.trim().toUpperCase()
                              );
                            }
                          );

                          if (findSizeItem) {
                            sizes.push(findSizeItem);
                          }
                        }
                      );

                      newProduct.Sizes =
                        sizes && sizes.length > 0 ? sizes : null;
                    }
                  }

                  if (element.Categorias)
                    newProduct.Categories = element.Categorias.split(",");

                  currentProducts.push(newProduct);
                }
              }
            });

            setIsLoadingData(false);

            if (props.SuscribeChanges) props.SuscribeChanges(currentProducts);
          }
        });
      }

      if (fileUploadRef.current) fileUploadRef.current.value = "";
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Row className="mb-3">
        {props.canUpdload ? (
          <>
            <Col xs={props.canDownload ? 6 : 12}>
              <FileUpdloadForm
                SuscribeChanges={(e: any) => onImportExcel(e)}
                ControlRef={fileUploadRef}
                Accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8, application/vnd.ms-excel;charset=UTF-8, text/csv;charset=UTF-8"
                Classname=""
              />
            </Col>
          </>
        ) : (
          <></>
        )}
        {props.canDownload ? (
          <Col className="text-end">
            <Button type="button" variant="outline-success" size="sm">
              <FontAwesomeIcon icon={"file-excel"} /> Exportar modelo xlsx
            </Button>

            <Button
              type="button"
              variant="outline-info"
              size="sm"
              className="mx-1"
            >
              <FontAwesomeIcon icon={"file-csv"} /> Exportar modelo csv
            </Button>
          </Col>
        ) : (
          <></>
        )}
      </Row>

      {!isLoadingData ? (
        <>
          <Form>
            {props.Elements.map((elemento: IProduct, indice: number) => {
              return (
                <>
                  <Row
                    className="justify-content-start mt-2"
                    key={`row-product`}
                  >
                    <Col xs={1} className="products-form-position-input">
                      <InputTextForm
                        // eslint-disable-next-line react/jsx-no-undef
                        Label={
                          indice === 0
                            ? intl.formatMessage({
                                id: "ready-size-model",
                                defaultMessage: "Model",
                              })
                            : ""
                        }
                        MaxLength={25}
                        Placeholder={"AA1000"}
                        DefaultValue={elemento.Code}
                        Helper={indice === 0 ? helperModelo() : null}
                        SuscribedChange={(e: any) =>
                          onProductCodeChange(indice, e, elemento)
                        }
                      />
                    </Col>
                    <Col className="products-form-description-input">
                      <InputTextForm
                        Label={
                          indice === 0
                            ? intl.formatMessage({
                                id: "ready-size-description",
                                defaultMessage: "Descripción",
                              })
                            : ""
                        }
                        MaxLength={255}
                        Placeholder={"JACKET RUSTIC LINEN WASH	"}
                        DefaultValue={elemento.Name}
                        SuscribedChange={(e: any) =>
                          onProductNameChange(indice, e, elemento)
                        }
                      />
                    </Col>
                    <Col xs={1} className="products-form-position-input">
                      <SelectBodyArea
                        Label={
                          indice === 0
                            ? intl.formatMessage({
                                id: "ready-size-position",
                                defaultMessage: "Posición",
                              })
                            : ""
                        }
                        DefaultValue={elemento.BodyArea?.Id}
                        SuscribedChange={(e: any) =>
                          onProductBodyAreaChange(indice, e, elemento)
                        }
                      />
                    </Col>
                    <Col xs={1} className="products-form-gender-input">
                      <SelectGenders
                        Label={
                          indice === 0
                            ? intl.formatMessage({
                                id: "ready-size-gender",
                                defaultMessage: "Género",
                              })
                            : ""
                        }
                        DefaultValue={elemento.Gender?.Id}
                        SuscribedChange={(e: any) =>
                          onProductGenderChange(indice, e, elemento)
                        }
                      />
                    </Col>
                    <Col xs={1} className="products-form-fit-input">
                      <SelectFitType
                        Label={
                          indice === 0 ? (
                            <FormattedMessage
                              id="ready-size-fit"
                              defaultMessage="Fit"
                            />
                          ) : (
                            ""
                          )
                        }
                        DefaultValue={elemento.Fit?.Id}
                        SuscribedChange={(e: any) =>
                          onProductFitChange(indice, e, elemento)
                        }
                      />
                    </Col>
                    <Col xs={4} className="products-form-talles-input">
                      <ChipsControl
                        Title={
                          indice === 0 ? (
                            <FormattedMessage
                              id="ready-size-sizes"
                              defaultMessage="Talles"
                            />
                          ) : (
                            ""
                          )
                        }
                        placeholder={""}
                        Values={elemento.Sizes?.map(
                          (option: { Name: string }) => option.Name
                        )}
                        onChipChange={(e: any) => onSizesChange(e)}
                        disabled={chipsDisabled}
                      />
                    </Col>
                    {elemento.SizeGuide ? (
                      <Col xs={1} className="text-center">
                        {indice === 0 ? (
                          <Form.Label className="font-label-form">
                            <FormattedMessage id="ready-size-guide" />
                          </Form.Label>
                        ) : (
                          <></>
                        )}
                        <button
                          className="product-form-associate-guide text-secondary"
                          style={{ marginTop: indice === 0 ? "5px" : "5px" }}
                          type="button"
                          onClick={(e: any) => onShowModal(indice, elemento)}
                        >
                          <span className="text-no-wrap-single-line">
                            {elemento.SizeGuide?.Name}
                          </span>
                        </button>
                      </Col>
                    ) : (
                      <Col
                        xs={1}
                        className="text-center product-form-associate-guide-container"
                      >
                        {indice === 0 ? (
                          <Form.Label className="font-label-form">
                            <FormattedMessage id="ready-size-guide" />
                          </Form.Label>
                        ) : (
                          <></>
                        )}
                        <div className="productform-associate-buttons-container">
                          <button
                            className="product-form-associate-guide"
                            type="button"
                            onClick={(e: any) => onShowModal(indice, elemento)}
                          >
                            <FormattedMessage
                              id="ready-size-associate-guide"
                              defaultMessage=" Asociar guía"
                            />
                          </button>
                          <button
                            className="btn-times-close"
                            type="button"
                            onClick={(e) => onProductRemove(indice, elemento)}
                          >
                            <FontAwesomeIcon
                              icon={"times"}
                              className="text-secondary"
                            />
                          </button>
                        </div>
                      </Col>
                    )}
                  </Row>
                </>
              );
            })}
          </Form>

          <Row className="mt-3">
            <Col>
              <span
                className="btn-sizeguide-form"
                onClick={() => onProductAdd()}
              >
                <FontAwesomeIcon
                  icon={"plus"}
                  className="text-fitprenda-warning"
                />
                <span className="font-fitprenda-button-add-size ms-2">
                  <FormattedMessage id="product-form-addproduct" />
                </span>
              </span>
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Form>
            <Row className="justify-content-start mt-2">
              <Col xs={1} aria-hidden="true">
                <Placeholder as="p" animation="glow" size="lg">
                  <Placeholder
                    xs={12}
                    bg="secondary"
                    style={{ borderRadius: "5px" }}
                  />
                </Placeholder>
              </Col>
            </Row>
          </Form>
        </>
      )}

      <ModalCommon
        Title={"Asociar Guía de talles"}
        buttonSuccessTitle={"Asociar"}
        Show={showModal}
        OnModalClose={onHideModal}
        OnModalOk={onOkModal}
        Content={ModalContent()}
        HiddenTitle={false}
        HiddenActions={false}
      />
    </>
  );
};

export default ProductsForm;
